import clsx from "clsx";
import React, { memo, useEffect, useRef, useState } from "react";
import { ArrowDown } from "../../../core/consts/redesign/icons";
import useOutsideClickDetector from "../../../core/hooks/useOutsideClickDetector";
import { OptionType } from "../../../core/types/common";
import classes from "./FilterProducts.module.scss";

/* Redesign . select for key value options choice with dropdown list */

type PropsType = {
  onChange: (val: OptionType) => void;
  label: string;
  value: string;
  options: OptionType[];
  placeholder?: string;
  id?: string;
  noBorder?: boolean;
  setIsFiltersChanged?: React.Dispatch<React.SetStateAction<boolean>>;
}

const SelectDropdownKeyValue = ({
  label,
  placeholder,
  id,
  value,
  onChange,
  options,
  noBorder,
  setIsFiltersChanged
}: PropsType) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState(value);
  const divRef = useRef<HTMLDivElement>(null);
  useOutsideClickDetector(divRef, () => setIsOpen(false));

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const handleOptionClick = (option: OptionType) => {
    setInputValue(option.label);
    onChange(option);
    setIsOpen(false);
    if (setIsFiltersChanged) setIsFiltersChanged(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(e.target.value);
  };

  return (
    <div className={clsx(classes.inputContainer, {
      [classes.inputContainerNoBorder]: noBorder
    })}
      id={id}
      ref={divRef}
    >
      <label className={classes.label}>{label}</label>
      <div className={clsx(classes.selectContainer, {
        [classes.selectContainerOpen]: isOpen,
        [classes.selectContainer]: !isOpen
      })}
        onClick={() => setIsOpen(!isOpen)}
        tabIndex={0}
      >
        <input
          type="text"
          value={inputValue}
          onChange={handleInputChange}
          className={classes.select}
          placeholder={placeholder}
        />
        <div className={classes.chevronIcon} >
          <ArrowDown />
        </div>
      </div>
      {isOpen && (
        <div className={classes.smallDropdownList}>
          {options?.map((option, index) => (
            <div
              key={index}
              className={clsx(classes.smallDropdownItem, {
                [classes.blueItem]: option.value === inputValue
              })}
              style={{ marginBottom: 0 }}
              onMouseDown={() => handleOptionClick(option)}
            >
              <div className={classes.optionItem}>
                {option.label}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

  );
}

export default memo(SelectDropdownKeyValue)
